import { IReaderAdmin } from "../models/IReader";
import { axiosInstance } from "./ServiceConstants";
import { CancelToken } from "axios";

class ReaderService {
  async deleteReader(readerId: string) {
    await axiosInstance.delete(`api/readers/${readerId}`);
  }
  async upsertReader(reader: IReaderAdmin): Promise<IReaderAdmin> {
    const readersResponse = await axiosInstance.post<IReaderAdmin>(
      "api/readers",
      reader
    );
    return readersResponse.data;
  }
  async getReaders(cancelToken?: CancelToken): Promise<IReaderAdmin[]> {
    const readersResponse = axiosInstance.get<IReaderAdmin[]>("api/readers", { cancelToken });
    return (await readersResponse).data;
  }
}

const ReaderServiceInstance = new ReaderService();

export default ReaderServiceInstance;
